module.exports = __webpack_public_path__ + "img/chinesecompany136.5a01889e.png";